import React from 'react';
import { motion, AnimatePresence } from '@utils/framerMotionProxy';
import { useTranslation } from 'react-i18next';

const PrivacyPolicyModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.9 }}
          transition={{ duration: 0.3 }}
          className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-hidden"
        >
          <div className="p-6 max-h-[90vh] overflow-y-auto">
            <div className="prose max-w-none">
              <div className="text-lg leading-relaxed space-y-4">
                {t('privacyPolicy.content', { returnObjects: true }).map((section, index) => (
                  <div key={index}>
                    {section.title && (
                      <h3 className="text-xl font-semibold mb-3 text-gray-900">
                        {section.title}
                      </h3>
                    )}
                    {section.content && (
                      <div className="text-gray-700 whitespace-pre-line">
                        {section.content}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
            
            <div className="flex justify-center mt-8">
              <button
                onClick={onClose}
                className="px-8 py-3 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors font-medium shadow-lg"
              >
                {t('common.close')}
              </button>
            </div>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export default PrivacyPolicyModal;
